import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { RESIZE_URL } from 'utils/restapi';
import { patchProductLink } from 'redux/catalog/actions';

import CommonImageDropzone from 'components/common/CommonImageDropzone';

import './ProductItemThumbnail.css';

class ProductItemThumbnail extends Component {
  static propTypes = {
    patchProductLink: PropTypes.func.isRequired,
    productId: PropTypes.number.isRequired,
    thumbnail: PropTypes.string,
  };

  static defaultProps = {
    thumbnail: null,
  };

  state = {
    showLoader: false,
  };

  _onImageRemove = () => {
    const form = new FormData();
    form.append('thumbnail', '');
    this.props.patchProductLink(this.props.productId, form);
  };

  _onImageDrop = droppedImage => {
    if (droppedImage) {
      const form = new FormData();
      form.append('thumbnail', droppedImage.imageBlob, droppedImage.name);
      this.props.patchProductLink(this.props.productId, form);
    }

    this.setState({ showLoader: true });
  };

  render() {
    const { thumbnail } = this.props;

    return (
      <div
        className="product-item-thumbnail__component"
        style={{ backgroundImage: thumbnail && `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=96/${thumbnail})` }}
      >
        {thumbnail &&
          <div
            className="delete-icon"
            onClick={this._onImageRemove}
            role="button"
            tabIndex={-1}
          />
        }
        <CommonImageDropzone
          onDropImage={this._onImageDrop}
        />
      </div>
    );
  }
}

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    patchProductLink,
  },
)(ProductItemThumbnail);
